import { TFunction } from 'i18next';
import * as yup from 'yup';

import { translations } from 'locales/i18n';

export const revenueTypeSettingsValidationSchema = (t: TFunction<'translation', undefined>) =>
  yup.object().shape({
    revenueTypeNumber: yup
      .number()
      .typeError(t(translations.pages.billingSettings.validation.revenueType()))
      .required(t(translations.validation.required())),
    description: yup.string().required(t(translations.validation.required())).trim()
  });

export const useRevenueTypeSettingsInitialValue = (revenueType: any | undefined) => {
  return revenueType
    ? {
        revenueTypeNumber: revenueType.revenueTypeNumber,
        description: revenueType.description
      }
    : {
        revenueTypeNumber: undefined,
        description: undefined
      };
};
